import React, { useState } from "react";
import Logo from "./Logo";
import "./AuthFlow.css";

import IMG_LOGIN_HERO from "../../assets/images/login_hero.png";

import ICON_MAIL from "../../assets/icons/icon-envelope.svg";
import ICON_KEY from "../../assets/icons/icon-key.svg";
import ICON_EYE from "../../assets/icons/icon-eye.svg";

const NAV_LINKS = ["Home", "Features", "How It Works", "Pricing", "Resources"];

function GoogleIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path d="M18.62 9.7c0-.62-.06-1.22-.16-1.8H9.5v3.42h5.13a4.39 4.39 0 01-1.9 2.88v2.4h3.08c1.8-1.66 2.84-4.1 2.84-6.9z" fill="#4285F4"/>
      <path d="M9.5 19c2.57 0 4.72-.85 6.3-2.3l-3.08-2.4c-.85.57-1.94.91-3.22.91-2.48 0-4.58-1.67-5.33-3.92H1v2.47A9.5 9.5 0 009.5 19z" fill="#34A853"/>
      <path d="M4.17 11.29a5.7 5.7 0 010-3.58V5.24H1a9.5 9.5 0 000 8.52l3.17-2.47z" fill="#FBBC05"/>
      <path d="M9.5 3.79c1.4 0 2.65.48 3.64 1.42l2.73-2.73C14.21.98 12.06 0 9.5 0A9.5 9.5 0 001 5.24l3.17 2.47C4.92 5.46 7.02 3.79 9.5 3.79z" fill="#EA4335"/>
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
      <circle cx="9.5" cy="9.5" r="9.5" fill="#1877F2" />
      <path d="M12.6 9.7h-2.03v6.7H7.98V9.7H6.5V7.4h1.48V5.94c0-1.61.72-2.84 3-2.84.65 0 1.34.1 1.34.1v2.06h-.99c-.98 0-1.3.53-1.3 1.24V7.4h2.2l-.33 2.3z" fill="#fff"/>
    </svg>
  );
}

export default function LoginPage({ onLogin, onGoRegister }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="auth-page auth-login-page">
      <img src={IMG_LOGIN_HERO} alt="" className="auth-login-bg" />
      <div className="auth-login-scrim" />

      {/* ── top nav ── */}
      <header className="auth-navbar">
        <Logo light />
        <nav className="auth-navlinks">
          {NAV_LINKS.map((l, i) => (
            <a key={l} href="#" className={`auth-navlink${i === 0 ? " is-active" : ""}`}>
              {i === 0 && <span className="auth-navlink-dot" />}
              {l}
            </a>
          ))}
        </nav>
        <button type="button" className="auth-btn auth-btn-solid auth-navbar-cta">Get Started Free</button>
      </header>

      {/* ── headline (bottom-left, overlaying the photo) ── */}
      <div className="auth-login-marketing">
        <h1 className="auth-login-headline">
          Turn Offers<br />into<br /><span>Opportunities.</span>
        </h1>
      </div>

      {/* ── login card (right, vertically centered) ── */}
      <div className="auth-card-wrap">
        <div className="auth-card">
          <h2 className="auth-card-title">
            Welcome to<br /><span>Couponbook</span>
          </h2>

          <button type="button" className="auth-social-btn">
            <GoogleIcon /> Login with Google
          </button>
          <button type="button" className="auth-social-btn">
            <FacebookIcon /> Login with Facebook
          </button>

          <div className="auth-divider"><span>OR</span></div>

          <label className="auth-field">
            <img src={ICON_MAIL} alt="" className="auth-field-icon" />
            <div>
              <div className="auth-field-label">Email</div>
              <input type="email" placeholder="example@gmail.com" autoComplete="email" />
            </div>
          </label>

          <label className="auth-field">
            <img src={ICON_KEY} alt="" className="auth-field-icon" />
            <div>
              <div className="auth-field-label">Password</div>
              <input type={showPassword ? "text" : "password"} placeholder="••••••••••••" autoComplete="current-password" />
            </div>
            <button
              type="button"
              className="auth-field-toggle"
              onClick={() => setShowPassword((s) => !s)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <img src={ICON_EYE} alt="" />
            </button>
          </label>

          <div className="auth-row-between">
            <label className="auth-checkbox">
              <input type="checkbox" />
              <span className="auth-checkbox-box" />
              Remember me
            </label>
            <a href="#" className="auth-link">Forgot Password?</a>
          </div>

          <button type="button" className="auth-btn auth-btn-solid auth-btn-block" onClick={onLogin}>
            Login
          </button>

          <p className="auth-footer-text">
            Don't have an account? <a href="#" className="auth-link" onClick={(e) => { e.preventDefault(); onGoRegister?.(); }}>Register</a>
          </p>
        </div>
      </div>
    </div>
  );
}